// extracted by mini-css-extract-plugin
export default {"urgentTitling":"CopywritePendingTitlingFilter_urgentTitling__jhj10","urgentTitlingActive":"CopywritePendingTitlingFilter_urgentTitlingActive__vR94B"};